import superagent from '@ott/superagent';

import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { RequestError } from './types';

const url = '/_mark/buyerGroups/';

export const getUserGroups = createAsyncThunk<string[], void, { rejectValue: RequestError }>(
  'userGroups/getUserGroups/fetching',
  async (params, { rejectWithValue }) => {
    try {
      const {
        body: { error, result },
      } = await superagent.get(url).withCredentials();

      if (error) {
        throw error;
      }
      return result as string[];
    } catch (error: any) {
      return rejectWithValue(error.response.body as RequestError);
    }
  }
);

export const resetUserGroups = createAction('userGroups/userGroupsReset');
